import { PostModel } from "common/models/baseModel";
import { useQuery } from "@tanstack/react-query";
import { institute } from "./query";
import { IInstituteGridFilter } from "./types";

export function useListQuery(model: PostModel<IInstituteGridFilter>) {
  return useQuery(institute.list(model));
}

export function useGetQuery(id: number) {
  return useQuery({
    ...institute.get(id),
    enabled: id > 0,
  });
}

export function useViewQuery(id: number, isOpen: boolean) {
  return useQuery({
    ...institute.view(id),
    enabled: id > 0 && isOpen,
  });
}

export function useValuesQuery() {
  return useQuery(institute.useAllInstituteValue);
}

export function useCommunityWiseValuesQuery() {
  return useQuery(institute.communityWiseValues);
}

// export function useUniversiytValuesQuery() {
//   return useQuery(institute.universityValues);
// }

export function useProgramByInstituteValues(id: number) {
  return useQuery(institute.useProgramByInstituteValues(id));
}

export function useValuesByCommunityIdQuery(communityID: number) {
  return useQuery({
    ...institute.valuesByCommunityId(communityID),
    enabled: communityID > 0,
  });
}

export function useCourseRolebyInstituteValues(id: number) {
  return useQuery({
    ...institute.useCourseRolebyInstituteValues(id),
    refetchOnMount: false,
    staleTime: 60000,
    enabled: id !== undefined,
  });
}
